import { Sparkles } from "lucide-react";

export default function NewReleaseBadge({ large = false }) {
  return (
    <div
      data-testid="new-release-badge"
      className={`new-release-badge absolute top-[42%] left-0 z-10 flex items-center gap-1.5 bg-primary-gold text-[#0B0C10] font-mono-ui uppercase font-semibold shadow-[0_6px_20px_rgba(0,0,0,0.5)] ${
        large ? "text-xs tracking-[0.22em] pl-5 pr-6 py-2" : "text-[10px] tracking-[0.2em] pl-3 pr-4 py-1.5"
      }`}
    >
      <Sparkles className={large ? "w-4 h-4" : "w-3 h-3"} /> Just Released
    </div>
  );
}
